/**
 * Segmento con el que se arma la URL publica de la tienda.
 *
 * El nombre se muestra tal como lo escribio el comercio; la URL usa esta forma
 * normalizada. Debe coincidir con CatalogueUrlHelper::urlSegment del backend:
 * minusculas, sin tildes ni dieresis, y espacios convertidos en guion.
 */
export const catalogueUrlSegment = (name: string): string =>
  (name ?? "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replaceAll(" ", "-");

export default catalogueUrlSegment;
